import React from 'react';
import { connect } from 'react-redux';
import FormDropdown from './FormDropdown';
import Pagination from './Pagination';
import Bar from './Bar';
import {
    updateModalContent,
    setCurrentPage,
    setPaginateCount,
    ajaxChatFilterV2,
    setCustomTimeframe,
    setSorting
} from '../redux/FeedbackRedux';

class FilterMessageBar extends React.Component {
    constructor(props) {
        super(props);
    }

    doPagination() {
        let e = event.target;
        let np = $(e).attr("data-direction");
        let current = this.props.state.current_page;
        switch (np) {
            case "next":
                console.log("yup");
                current += 1;
                break;
            case "prev":
                console.log("nope");
                current -= 1;
                break;
        }
        this.props.dispatch(setCurrentPage(current));
        this.props.dispatch(ajaxChatFilterV2());
    }

    doPaginationCount() {
        let count = parseInt($(event.target).text());
        this.props.dispatch(setPaginateCount(count));
        this.props.dispatch(setCurrentPage(1));
        this.props.dispatch(ajaxChatFilterV2());
    }

    doChangeTimeFrame() {
        const prev = jQuery("#start_date").val();
        const next = jQuery("#end_date").val();

        if (prev > next) {
            jQuery("#start_date").blur();
            jQuery("#end_date").blur();
            this.props.dispatch(updateModalContent({ modal_id: "date_late_error", modal_title: __('End Date must be later than the Start Date.'), modal_body: '', button_1_class: 'primary', button_1_id: 'cancel', button_1_text: __('Ok') }));
            jQuery('.modal:not(.error)').modal();
            return;
        }

        window.localStorage.setItem("chat_prev_date", prev);
        window.localStorage.setItem("chat_next_date", next);

        this.props.dispatch(setCustomTimeframe({ next, prev }));
        this.props.dispatch(setCurrentPage(1));
        this.props.dispatch(ajaxChatFilterV2());
    }

    doSorting() {
        let data = $(event.target).data('value');

        if (data === undefined) {
            data = $(event.target).children().first().data('value');
        }

        this.props.dispatch(setSorting(data));
        this.props.dispatch(ajaxChatFilterV2());
    }

    getSortingName(sortId) {
        const sortNames =
            {
                'sort-created_at-desc': __('Date Newest'),
                'sort-created_at-asc': __('Date Oldest'),
                'sort-priority-desc': __('High priority'),
                'sort-priority-asc': __('Low priority'),
            };

        return sortNames[sortId];
    }

    render() {
        return (
            <Bar>
                <div className="d-flex align-items-center">
                    {this.props.state.timeframe === "custom" && (
                        <div className="">
                            <input
                                className="form-control"
                                value={this.props.state.timeframe_prev}
                                onChange={() => { this.doChangeTimeFrame() }}
                                type="date"
                                min='1899-01-01'
                                max={this.props.state.max_Date}
                                id="start_date"
                                required
                            />
                        </div>
                    )}
                    {this.props.state.timeframe === "custom" && (
                        <div className="">{__('To')}</div>
                    )}
                    {this.props.state.timeframe === "custom" && (
                        <div className="">
                            <input
                                className="form-control"
                                value={this.props.state.timeframe_next}
                                onChange={() => { this.doChangeTimeFrame() }}
                                type="date"
                                min='1899-01-01'
                                max={this.props.state.max_Date}
                                id="end_date"
                                required
                            />
                        </div>
                    )}
                </div>
                <FormDropdown
                    classes="d-flex align-items-center mr-2 ml-auto"
                    menuClasses="thin-menu"
                    buttonClasses="p-1 bg-white no-arrow"
                    title={<>
                        <span
                            className={'mr-1'}>{ __('Sort by') }: {this.getSortingName((!this.props.state.sorting || this.props.state.sorting === 'null') ? 'sort-created_at-desc' : this.props.state.sorting)}</span>
                        <img src="/img/filter.svg"></img>
                    </>}
                    itemOnClickFunction={this.doSorting.bind(this)}
                    items={[
                        { text: <><span className="mr-4" data-value="sort-priority-desc">{__('High Priority')}</span><i className="text-gray fas fa-chevron-up" data-value="sort-priority-desc"></i></> },
                        { text: <><span className="mr-4" data-value="sort-priority-asc">{__('Low Priority')}</span><i className="text-gray fas fa-chevron-down" data-value="sort-priority-asc"></i></> },
                        { text: <><span className="mr-auto" data-value="sort-created_at-desc">{__('Date Newest')}</span><i className="text-gray fas fa-chevron-up" data-value="sort-created_at-desc"></i></> },
                        { text: <><span className="mr-auto" data-value="sort-created_at-asc">{__('Date Oldest')}</span><i className="text-gray fas fa-chevron-down" data-value="sort-created_at-asc"></i></> }
                    ]}
                />
                <FormDropdown
                    classes="d-flex align-items-center mr-2"
                    menuClasses="thin-menu roboto"
                    buttonClasses="p-1 bg-white roboto"
                    itemOnClickFunction={this.doPaginationCount.bind(this)}
                    title={this.props.state.paginate_count}
                    items={[
                        { text: "10" },
                        { text: "25" },
                        { text: "50" },
                        { text: "100" }
                    ]}
                />
                <Pagination
                    onNextClick={this.doPagination.bind(this)}
                    onPrevClick={this.doPagination.bind(this)}
                    total={this.props.state.feedback_count}
                    increment={this.props.state.paginate_count}
                />
            </Bar>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FilterMessageBar);
